export default __webpack_public_path__ + "static/media/spiral.dec53a46.png";